module.exports = __webpack_public_path__ + "img/next_icon.2c36ad0.png";